import { convertDataToCamelCase } from '~/helpers';
import {
    AddonCatalogEntry,
    Allocation,
    Announcement,
    ApiKey,
    AuditLog,
    Backup,
    CatalogEntry,
    CurrentMapFiles,
    DatabaseHost,
    Domain,
    Egg,
    EggVariable,
    Features,
    File,
    FileDeletion,
    FirewallRule,
    GitWebhook,
    License,
    Location,
    MapRotation,
    MigrationEntity,
    Mod,
    Modpack,
    ModpackBuild,
    ModpackBuildLogs,
    ModpackVersion,
    Node,
    Notification,
    PanelMigration,
    PersonalAccessToken,
    Plugin,
    RunTask,
    RustPermissionGroup,
    RustPermissionOp,
    RustPermissionSettings,
    RustPermissionUser,
    RustServerImage,
    Schedule,
    ScheduleRun,
    ScheduleTask,
    SecurityKey,
    SentEmail,
    Server,
    ServerDatabase,
    ServerSubdomain,
    ServerSubuser,
    ServerTemplate,
    ServerTemplateSchedule,
    ServerTemplateTask,
    ServerTransfer,
    ServerVariable,
    SSHKey,
    SsoLoginFailure,
    SwitchGroup,
    Tag,
    User,
    WipeSchedule,
} from './models';

export class Parser {
    static models: Record<string, any> = {
        addon: AddonCatalogEntry,
        allocation: Allocation,
        announcement: Announcement,
        api_key: ApiKey,
        audit_log: AuditLog,
        backup: Backup,
        catalog_entry: CatalogEntry,
        current_map_files: CurrentMapFiles,
        database_host: DatabaseHost,
        domain: Domain,
        database: ServerDatabase,
        egg: Egg,
        egg_variable: EggVariable,
        features: Features,
        file: File,
        firewall_rule: FirewallRule,
        git_webhook: GitWebhook,
        license: License,
        location: Location,
        mod: Mod,
        modpack: Modpack,
        modpack_build: ModpackBuild,
        modpack_build_logs: ModpackBuildLogs,
        modpack_version: ModpackVersion,
        node: Node,
        notification: Notification,
        panel_migration: PanelMigration,
        panel_migration_entity: MigrationEntity,
        personal_access_token: PersonalAccessToken,
        plugin: Plugin,
        rust_permission_settings: RustPermissionSettings,
        rust_permission_group: RustPermissionGroup,
        rust_permission_user: RustPermissionUser,
        rust_permission_op: RustPermissionOp,
        rust_server_image: RustServerImage,
        schedule: Schedule,
        schedule_run: ScheduleRun,
        schedule_task: ScheduleTask,
        run_task: RunTask,
        security_key: SecurityKey,
        sent_email: SentEmail,
        server: Server,
        server_subdomain: ServerSubdomain,
        server_subuser: ServerSubuser,
        server_template: ServerTemplate,
        server_template_schedule: ServerTemplateSchedule,
        server_template_task: ServerTemplateTask,
        server_transfer: ServerTransfer,
        server_variable: ServerVariable,
        ssh_key: SSHKey,
        sso_login_failure: SsoLoginFailure,
        switch_group: SwitchGroup,
        tag: Tag,
        user: User,
        file_deletion: FileDeletion,
        map_rotation: MapRotation,
        wipe_schedule: WipeSchedule,
    };

    static parse(response: APIResponse, returnDataOnlyForLists = false): any {
        if (response.object === 'list') {
            const listResp = response as ListResponse;
            const data = listResp.data.map((item) => Parser.parse(item));

            return returnDataOnlyForLists
                ? data
                : {
                      object: listResp.object,
                      data,
                      meta: convertDataToCamelCase(listResp.meta),
                  };
        } else {
            response = response as ModelResponse;
            const { object, attributes, meta } = response;
            if (object === 'null_resource') return null;

            const relationships: Record<string, any> = {};
            if (attributes.relationships) {
                for (const relationship in attributes.relationships) {
                    relationships[relationship] = Parser.parse(convertDataToCamelCase(attributes.relationships[relationship]), true);
                }

                delete attributes.relationships;
            }

            if (meta?.extra_objects) {
                for (const extra of meta.extra_objects) relationships[extra.object] = convertDataToCamelCase(extra.attributes);
            }

            if (!Parser.models[response.object]) {
                throw new Error(`API Parser: Model '${response.object}' is not registered?`);
            }

            return new Parser.models[response.object]().initialize(convertDataToCamelCase(attributes), relationships);
        }
    }
}
